import { cn } from '@/layers/support/cn';
import React from 'react';

interface ContainerProps extends React.HTMLAttributes<HTMLDivElement> {
  noBottomMargin?: boolean;
}
export function Container({ noBottomMargin, className, children, ...rest }: ContainerProps) {
  return (
    <div
      className={cn(
        // Responsive top padding (sm:32px, lg:64px). These survive purging now
        // that Container is in the marketing Tailwind allow-list (B1 root-cause
        // fix in tailwind.marketing.config.ts), so no non-responsive base is
        // needed — keeping it responsive-only avoids adding mobile top-padding to
        // app dashboards that already wrap Container in py-12.
        'container mx-auto px-4 sm:px-6 lg:px-8 sm:pt-8 lg:pt-16',
        noBottomMargin ? 'mb-0' : 'mb-16',
        className,
      )}
      {...rest}
    >
      {children}
    </div>
  );
}
